import axios from '../../plugins/axios.js';

export default{
  async getPrompts() {
    return await axios.get('/api/Prompt');
  },
  async getPromptByID(promptID) {
    return await axios.get(`/api/Prompt/${promptID}`);
  },
  async getPromptStatuses() {
    return await axios.get('/api/Prompt/PromptStatus');
  },
  async getLanguages() {
    return await axios.get('/api/Language');
  },
  async getVoices() {
    return await axios.get(`/api/Voice`);
  },
  async creartPrompt(prompt) {
    return await axios.post('/api/Prompt', prompt);
  },
  async updatePrompt(prompt) {
    return await axios.put('/api/Prompt', prompt);
  },
  async archivePrompt(promptValues) {
    return await axios.post('/api/Prompt/ArchivePrompt', promptValues);
  },
  async convertTextToVoice(promptScript) {
    return await axios.post('/api/Polly/ConvertTextToVoice',promptScript, {responseType: 'blob'});
  },
  async getPromptAudioByID(promptID) {
    return await axios.get(`api/Polly/ConvertPromptToVoice?promptID=${promptID}`,{responseType: 'blob'});
  },
  async UpdateUsedPrompt(prompt){
    return await axios.put('/api/Prompt/UpdateUsedPrompt', prompt);
  },
  async getPromptDropDowns() {
    return await axios.get(`/api/Prompt/GetPromptDropDowns`);
  },

};
